export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q02_a.35f4d68c.png";